var componentRequireContext = require.context("components", true, /front\/applicants\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);